export default __webpack_public_path__ + "static/media/Foot_left.89df62df.svg";